module.exports = __webpack_public_path__ + "img/sld_metering_panel_em_t1_b1.9705a6f0.svg";